<div id="imgtruck" class="carousel slide" data-ride="carousel">
    <div class="carousel-inner ">
        <div class="carousel-item active">
            <img src="/assets/d.header/Foto1.png" class="d-block w-100" alt="...">
            <div class="overlay">
                <div class="container-fluid">
                    <div class="row align-top-titles">
                        <div class="col col-md-6 offset-1 text-left">
                            <div class="tittles">
                                <h1 class="text__tittles">Encuentra las mejores<br> cargas para tu camion</h1>
                                <h3 class="text__tittles--sub">tenemos para ti mas de 300 cargas disponibles para
                                    transportar <br>
                                    en todo el pais !y cada vez se suman mas!</h3><br>
                                <div class="col-md-2">
                                    <mat-card-actions class="actions-card">
                                        <button mat-raised-button color="primary" class="button-width-auto">
                                            Calificar
                                        </button>
                                    </mat-card-actions>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container">
    <div class="col-12 col-lg-12 margin-text">
        <h1 class="text__info--details">Teclogi te conecta con carga disponible de manera<h2 class="text__info--purple">
                segura y transparente, sin intermediarios</h2>
        </h1>
    </div>
</div>
<div class="container">
    <div class=" row">
        <div class="col-lg-6 col-md-6 col-sm-6">
            <img src="/assets/d.header/shutterstock_1171923346@2x.png" class="img-fluid" alt="soy transportador">
        </div>
        <!--section2-->
        <div class="col-lg-6 col-md-6 col-sm-6">
            <div class="row margin-row">
                <div class="col-6 col-lg col-sm text-center images__info">
                    <img class="" src="/assets/d.header/Group.svg" alt="group">
                </div>
                <div class="col-6 text-left">
                    <h2 class=" title-purple">Ahorra tiempo en tus recorridos</h2>
                    <p>Optimizamos tus rutas de acuerdo a citas de entrega y restricciones viales para myor capacidad
                        de reparto</p>
                </div>
            </div>
            <div class="row margin-row">
                <div class="col-6 col-lg text-center images__info">
                    <img class="" src="/assets/d.header/Group.svg" alt="group">
                </div>
                <div class="col-6 col-lg text-left ">
                    <h2 class="title-purple">Aumenta tus ingresos</h2>
                    <p>Aumntamos tus ingresos con un mayor numero de viajes, reduciendo los tiempos muertos de
                        inactividad</p>
                </div>
            </div>
            <div class="row margin-row">
                <div class="col-6 col-lg text-center images__info">
                    <img class="" src="/assets/d.header/Group.svg" alt="group">
                </div>
                <div class="col-6 col-lg text-left">
                    <h2 class="title-purple">Encuentra tu carga ideal</h2>
                    <p>Enviamos buenas ofertas de carga para tu camion en cualquier momento y lugar</p>
                </div>
            </div>
            <div class="row margin-row">
                <div class="col-6 col-lg text-center images__info">
                    <img class="" src="/assets/d.header/Group.svg" alt="group">
                </div>
                <div class="col-6 col-lg text-left">
                    <h2 class="title-purple">Administra tus viajes</h2>
                    <p>Brindamos una sola herramienta de trabajo para la gestio y negociacion de tus viajes</p>
                </div>
            </div>
        </div>
    </div>
</div>